import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InstapayListComponent } from "../../../../components/admin-dashboard-component/instapay-accounts/instapay-list-component/instapay-list-component";
import { AddIcon } from "../../../../shared/ui/icons/add-icon/add-icon";

@Component({
  selector: 'app-list-instapay-accounts',
  imports: [InstapayListComponent, AddIcon],
  templateUrl: './list-instapay-accounts.html',
  styleUrl: './list-instapay-accounts.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListInstapayAccounts {

}
